module.exports = __webpack_public_path__ + "img/main_bose1.1cff2a05.jpg";